import useHistoryGoBack from 'hooks/useBackHistory';
import MobileHeader from 'UIKit/MobileHeader';

const CommonMobileHeader = ({ title, testId }: { title: string; testId: string }) => {
  const { goBack } = useHistoryGoBack();

  return <MobileHeader onBackButtonClick={goBack} title={title} testId={testId} />;
};

export default CommonMobileHeader;
